import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dealer-login',
  templateUrl: './dealer-login.component.html',
  styleUrls: ['./dealer-login.component.scss']
})
export class DealerLoginComponent implements OnInit {

  checkedFullname: boolean = false;
  checkedEmail: boolean = false;
  checkedPassword: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  goToHome() {
    window.location.href = '/homepage';
  }

  
  get currentYear(){
    return  new Date().getFullYear()
  }
}
